import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter, Youtube, Music2 } from "lucide-react";
import api from "../../lib/api";
import { trackEvent } from "../../lib/analytics";

const LEGAL = [
  ["kvkk-aydinlatma-metni", "KVKK Aydınlatma Metni"],
  ["gizlilik-politikasi", "Gizlilik Politikası"],
  ["cerez-politikasi", "Çerez Politikası"],
  ["mesafeli-satis-sozlesmesi", "Mesafeli Satış Sözleşmesi"],
  ["on-bilgilendirme-formu", "Ön Bilgilendirme Formu"],
  ["iptal-iade-kosullari", "İptal ve İade Koşulları"],
  ["kullanim-kosullari", "Kullanım Koşulları"],
  ["kargo-teslimat", "Kargo ve Teslimat"],
];

export default function Footer() {
  const [settings, setSettings] = useState(null);
  useEffect(() => { api.get("/settings/public").then(({ data }) => setSettings(data)).catch(() => {}); }, []);

  return (
    <footer className="bg-forest text-cream mt-20">
      <div className="max-w-7xl mx-auto px-4 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <img src={settings?.logo_url || "/logo.jpg"} alt="Ata Angora" className="h-12 w-12 rounded-full object-cover ring-2 ring-gold/50" />
            <div>
              <p className="font-serif font-bold text-lg">Ata Angora</p>
              <p className="text-[10px] uppercase tracking-[0.2em] text-cream/60">Doğal Gıdalar</p>
            </div>
          </div>
          <p className="text-sm text-cream/70 mt-4 leading-relaxed">{settings?.texts?.footer_about || "Anadolu'nun bereketli topraklarından sofranıza; doğal, katkısız ve laboratuvar analizli ürünler."}</p>
        </div>
        <div>
          <h4 className="font-semibold text-gold-light mb-4 text-sm uppercase tracking-wider">Hızlı Erişim</h4>
          <ul className="space-y-2 text-sm text-cream/80">
            <li><Link to="/urunler" className="hover:text-gold-light transition-colors">Tüm Ürünler</Link></li>
            <li><Link to="/urunler?etiket=cok-satan" className="hover:text-gold-light transition-colors">Çok Satanlar</Link></li>
            <li><Link to="/urunler?etiket=kampanya" className="hover:text-gold-light transition-colors">Kampanyalar</Link></li>
            <li><Link to="/blog" className="hover:text-gold-light transition-colors">Blog</Link></li>
            <li><Link to="/b2b" className="hover:text-gold-light transition-colors">B2B Toptan Satış</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold text-gold-light mb-4 text-sm uppercase tracking-wider">Yasal</h4>
          <ul className="space-y-2 text-sm text-cream/80">
            {LEGAL.map(([slug, label]) => (
              <li key={slug}><Link to={`/sayfa/${slug}`} className="hover:text-gold-light transition-colors">{label}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="font-semibold text-gold-light mb-4 text-sm uppercase tracking-wider">İletişim</h4>
          <ul className="space-y-2 text-sm text-cream/80">
            <li>{settings?.address}</li>
            <li>{settings?.phone && <a href={`tel:${String(settings.phone).replace(/\s/g, "")}`} data-testid="footer-phone-link" onClick={() => trackEvent("phone_click", { location: "footer" })} className="hover:text-gold-light transition-colors">{settings.phone}</a>}</li>
            <li>{settings?.email}</li>
            <li><Link to="/iletisim" className="hover:text-gold-light transition-colors">İletişim Formu</Link></li>
            <li><Link to="/soru-cevap" className="hover:text-gold-light transition-colors">Soru &amp; Cevap</Link></li>
          </ul>
          <div className="flex gap-2 mt-5 flex-wrap">
            {["Havale/EFT", "Kredi Kartı", "Kapıda Ödeme"].map((m) => (
              <span key={m} className="text-[10px] uppercase tracking-wider border border-cream/25 rounded-full px-2.5 py-1 text-cream/70">{m}</span>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-cream/10">
        <div className="max-w-7xl mx-auto px-4 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-cream/50">
          <div className="flex items-center gap-4 flex-wrap">
            <div className="flex gap-2.5">
              {[
                [settings?.instagram, Instagram, "instagram"],
                [settings?.facebook, Facebook, "facebook"],
                [settings?.twitter, Twitter, "twitter"],
                [settings?.youtube, Youtube, "youtube"],
                [settings?.tiktok, Music2, "tiktok"],
              ].filter(([url]) => url).map(([url, Icon, name]) => (
                <a key={name} href={url} target="_blank" rel="noreferrer" data-testid={`social-${name}`} aria-label={name} className="w-8 h-8 rounded-full border border-cream/25 flex items-center justify-center text-cream/70 hover:text-gold-light hover:border-gold/60 transition-colors">
                  <Icon className="w-3.5 h-3.5" />
                </a>
              ))}
            </div>
            <p>© 2026 Ata Angora Doğal Gıdalar. Tüm hakları saklıdır.</p>
          </div>
          <p>Güvenli alışveriş · 256-bit SSL · KVKK uyumlu</p>
        </div>
      </div>
    </footer>
  );
}
